import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@rocketmakers/armstrong";
import * as React from "react";
import { useRoutePaths } from "../../../../../shared/context/paths";
import { routePaths } from "../../../routes";
import "./header.scss";

export const Header: React.FunctionComponent = () => {
	const { user, logout } = useAuth0();
	const { push } = useRoutePaths();

	return (
		<header className="row header">
			{/* rome-ignore lint/a11y/useAltText: <explanation> */}
			{/* rome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
			<img
				src={require("../../../../assets/images/installer/sero-logo.svg")}
				className="sero-logo"
				onClick={() => push(routePaths.home.root)}
			/>
			<span className="spacer" />
			<div className="user-buttons">
				{user && (
					<Button className="btn-icon" name="Logout" onClick={() => logout()} title="Log Out">
						<img src={require("../../../../assets/images/installer/logout.svg")} alt="Log Out" width={40} />
					</Button>
				)}
			</div>
		</header>
	);
};
